/**
 * Cache de sesión del catálogo de productos de `InterfazV2` —
 * ADR-2026-08-04-la-marca-nueva-arranca-vacia.
 *
 * La llave vivía como constante privada dentro de `InterfazV2`, que es quien la
 * escribe y la lee. Sale acá porque ahora hay un segundo interesado: el alta de una
 * marca nueva, que tiene que **borrar** el catálogo de la marca anterior antes de
 * mandar a la home. Importar `InterfazV2` desde el onboarding para leer una constante
 * arrastraría un módulo de 6.000 líneas a ese bundle.
 *
 * Sólo la llave y el borrado: leer y escribir siguen siendo de `InterfazV2`, que es
 * donde vive el formato (el envelope `{ brandId, products }`).
 */
export const PRODUCTS_CACHE_KEY = 'atlas-v2-user-products-cache';

/**
 * Borra el catálogo cacheado. Lo llama quien sabe que lo guardado ya no aplica —
 * hoy, el alta de marca al confirmar.
 *
 * No hace falta borrarlo al CAMBIAR de marca desde el selector: el envelope guarda
 * `brandId` y la home limpia sola cuando no coincide con la marca activa. Acá se
 * borra igual porque la marca recién creada no tiene productos y lo que corresponde
 * mostrar es el estado vacío, no el catálogo anterior por un frame.
 */
export function limpiarCacheDeProductos(): void {
  try {
    sessionStorage.removeItem(PRODUCTS_CACHE_KEY);
  } catch {
    /* noop */
  }
}
